import { useTheme } from '@doxyme/ui-foundation/theme';
import { BodyS } from '@doxyme/ui-foundation/typography';

import type { JSX } from 'react';

type Props = {
  subtitle: string;
};

export const NotificationSubtitle = ({ subtitle }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <BodyS
      color={theme.text.generic.secondary}
      css={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {subtitle}
    </BodyS>
  );
};
